import { createTheme, ThemeOptions } from '@mui/material/styles';
import { lightPalette, darkPalette } from './palette';

const sharedThemeConfig: ThemeOptions = {
  typography: {
    fontFamily: '"Geist", "Inter", -apple-system, "SF Pro Text", system-ui, sans-serif',
    h1: {
      fontSize: '28px',
      fontWeight: 600,
      lineHeight: 1.25,
    },
    h2: {
      fontSize: '22px',
      fontWeight: 600,
      lineHeight: 1.3,
    },
    h3: {
      fontSize: '18px',
      fontWeight: 600,
      lineHeight: 1.4,
    },
    body1: {
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: 1.6,
    },
    body2: {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: 1.5,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
          borderRadius: 12,
          padding: '10px 20px',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
      },
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 10,
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        },
      },
    },
  },
};

export const lightTheme = createTheme({
  ...sharedThemeConfig,
  palette: lightPalette,
});

export const darkTheme = createTheme({
  ...sharedThemeConfig,
  palette: darkPalette,
});
